module.exports = __webpack_public_path__ + "media/images/svgs/jobs/file-dd4146751c28b1c31ada026935afb87a.svg";